export const OFFERS_INPUT_MAX = 99999;
export const OFFERS_INPUT_MIN = 0;
